import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import { observer, inject } from 'mobx-react';
import { Carousel } from 'react-responsive-carousel';
import Carouselstyles from 'react-responsive-carousel/lib/styles/carousel.min.css';
import styles from './CasePictureCarousel.css';
import { Button, Paper, Grid } from '@material-ui/core';

@inject('customerCaseStore')
@observer
class CasePictureCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { data } = this.props;
    let open = this.props.customerCaseStore.carouselOpen;
    let mobxSlideIndex = this.props.customerCaseStore.carouselPictureIndex;
    const imageURL = '/api/v1/images/';
    const carouselStyle = {
      position: 'absolute',
      top: 35
    };

    return (
      <Modal
        open={open}
        onBackdropClick={() => {
          this.props.customerCaseStore.carouselToggle();
        }}
      >
        <Grid style={carouselStyle} container xs={12}>
          <Grid
            item
            xs={12}
            sm={1}
            onClick={() => {
              this.props.customerCaseStore.carouselToggle();
            }}
          />
          <Grid item xs={12} sm={10} style={styles.carouselContainer}>
            <Carousel
              selectedItem={mobxSlideIndex}
              showArrows={true}
              dynamicHeight={true}
            >
              {data.map(p => (
                <div>
                  <img
                    src={imageURL + p._id}
                    style={{
                      ...styles.carouselPicture,
                      maxHeight: this.state.height - 199,
                      width: 'unset',
                      maxWidth: '100%'
                    }}
                  />
                  <p className="legend">{p.title}</p>
                </div>
              ))}
            </Carousel>
          </Grid>
          <Grid
            item
            xs={12}
            sm={1}
            onClick={() => {
              this.props.customerCaseStore.carouselToggle();
            }}
          />
        </Grid>
      </Modal>
    );
  }
}

export default CasePictureCarousel;

// Don't forget to include the css in your page

// Using webpack
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';

// Using html tag:
// <link rel="stylesheet" href="<NODE_MODULES_FOLDER>/react-responsive-carousel/lib/styles/carousel.min.css"/>



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/CasePictureCarousel/CasePictureCarousel.jsx